import { ChatType } from '../types/monitor/ChatType';
import { t } from 'i18next';

export const getChatTypeIcon = (chatType: ChatType | string | null | undefined): string | null => {
  if (!chatType || chatType === 'ALL') {
    return null;
  }

  switch (chatType) {
    case 'GEMINI':
    case 'GEMINI_BROWSER':
      return 'ico--gemini-bck';

    case 'GPT':
    case 'GPT_SEARCH':
    case 'GPT_BROWSER':
      return 'ico--gpt-bck';

    case 'CLAUDE':
      return 'ico--claude-bck';

    case 'DEEP_SEEK':
      return 'ico--deepseek-bck';

    case 'PERPLEXITY':
    case 'PERPLEXITY_BROWSER':
      return 'ico--perplexity-bck';

    case 'COPILOT_BROWSER':
      return 'ico--copilot-bck';

    case 'GROK':
    case 'GROK_BROWSER':
      return 'ico--grok-bck';

    case 'AI_OVERVIEW_NEW_BROWSER':
      return 'ico--ai-overview-bck';

    case 'AI_OVERVIEW_BROWSER':
    case 'AI_MODE_BROWSER':
      return 'ico--ai-mode';

    default:
      return null;
  }
};

export const getModelNameIcon = (modelName: string | null | undefined): string | null => {
  if (!modelName || modelName === 'ALL') {
    return null;
  }

  switch (modelName) {
    case 'GPT':
      return 'ico--gpt-bck';

    case 'GEMINI':
      return 'ico--gemini-bck';

    case 'CLAUDE':
      return 'ico--claude-bck';

    case 'DEEP_SEEK':
      return 'ico--deepseek-bck';

    case 'PERPLEXITY':
      return 'ico--perplexity-bck';

    case 'GROK':
      return 'ico--grok-bck';

    case 'COPILOT':
      return 'ico--copilot-bck';

    case 'AI_OVERVIEW':
      return 'ico--ai-overview-bck';

    case 'AI_MODE':
      return 'ico--ai-mode';

    default:
      return null;
  }
};

export const getModelNameLabel = (modelName: string | null | undefined): string => {
  switch (modelName) {
    case 'GPT':
      return t('gptName');

    case 'GEMINI':
      return t('geminiName');

    case 'CLAUDE':
      return t('claudeName');

    case 'DEEP_SEEK':
      return t('deepSeekName');

    case 'PERPLEXITY':
      return t('perplexityName');

    case 'GROK':
      return t('grokSearchName');

    case 'COPILOT':
      return t('copilotSearchName');

    case 'AI_OVERVIEW':
      return t('aiOverviewName');

    case 'AI_MODE':
      return t('aiModeName');

    default:
      return '';
  }
};
